import { App } from 'App';
import 'common/styles/antd.customize.less';
import 'common/styles/global.less';
import { Auth0ProviderWithHistory } from 'components/common/Auth0ProviderWithHistory';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import store from 'redux/store';
import * as serviceWorker from 'serviceWorker';

function render(): void {
  ReactDOM.render(
    <Provider store={store}>
      <BrowserRouter>
        <Auth0ProviderWithHistory>
          <App />
        </Auth0ProviderWithHistory>
      </BrowserRouter>
    </Provider>,
    document.getElementById('root')
  );
}

render();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
